import { resolveEffectiveTheme, useTheme } from '@/app/providers/theme-provider'
import { branding } from '@/config/branding'

interface LogoProps {
	/** Rendered height in pixels. Width follows the wordmark's aspect ratio. */
	height: number
}

function Logo({ height }: LogoProps) {
	const { theme } = useTheme()
	const source = resolveEffectiveTheme(theme) === 'light' ? branding.images.logoLight : branding.images.logoDark

	return (
		<img
			src={source}
			alt={`${branding.productName} logo`}
			className='w-auto object-contain'
			// Tailwind preflight sets `img { height: auto }`, which beats the height attribute.
			style={{ height }}
			data-testid='brand-logo'
		/>
	)
}

export default Logo
